<ape-page-placeholder
  [title]="TRANSLATION_KEYS.admin.impersonate.PLACEHOLDER.NO_RESULTS_TITLE | translate"
  [subtitle]="TRANSLATION_KEYS.admin.impersonate.PLACEHOLDER.NO_RESULTS_DESCRIPTION | translate"
/>
